import { OrderState } from '../types/orders';

/**
 * ¿Esta básica vinculada RESUELVE de verdad su tramo?
 *
 * Una actuación anulada ya no es trabajo: no resuelve nada. Es la regla del
 * backend desde el 2026-07-10 («anulada = libre»): el tramo se puede vincular
 * a otra actuación y el vínculo muerto se limpia al hacerlo. Pero hasta el
 * 2026-10-08 anular no soltaba el tramo, así que hay datos con un vínculo a
 * una anulada, y la interfaz decía «Resuelto por» una actuación muerta y
 * escondía «Vincular a actuación». Este es el único punto que lo decide para
 * la tarjeta del tramo, la tabla de Tramos y el informe PDF.
 *
 * Diagnóstico: `docs/superpowers/specs/2026-10-08-rv-parciales-diagnostico.md`.
 */
export const isLiveLinkedBasicAction = (
  linked?: { state?: string | null } | null
): boolean => !!linked && linked.state !== OrderState.Annulled;

/** La básica vinculada si resuelve el tramo; `null` si no hay o está anulada. */
export const liveLinkedBasicActionOrder = <T extends { state?: string | null }>(
  linked?: T | null
): T | null => (linked && isLiveLinkedBasicAction(linked) ? linked : null);

/**
 * ¿El tramo está pendiente de actuación? El aviso del backend
 * (`pendingActionLink`) manda, y además lo está si su única básica está
 * anulada, aunque el aviso aún no se haya actualizado.
 */
export const isSegmentPendingAction = (segment: {
  pendingActionLink?: boolean | null;
  linkedBasicActionOrder?: { state?: string | null } | null;
}): boolean =>
  !!segment.pendingActionLink ||
  (!!segment.linkedBasicActionOrder &&
    !isLiveLinkedBasicAction(segment.linkedBasicActionOrder));
